import React from 'react';
import {Box, Typography, Button, Card, CardMedia, CardContent, CardActions, Chip } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import Rating from '@material-ui/lab/Rating';
import { CssBaseline, Grid } from "@material-ui/core";

import useStyles from './style';
import { ImageSearch } from '@material-ui/icons';


const PlaceDetails = ({place, selected, refProp}) => {
    // console.log(place);

    if (selected) refProp?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const classes = useStyles();

    return (
    // <Grid container className = {classes.grid}>
        <Card elevation = {6} className = {classes.card}>
            <CardMedia 
                style = {{ height: 300}}
                image = {place.photo ? place.photo.images.large.url : 'https://www.google.com/imgres?imgurl=https%3A%2F%2Fsocialistmodernism.com%2Fwp-content%2Fuploads%2F2017%2F07%2Fplaceholder-image.png%3Fw%3D640&imgrefurl=https%3A%2F%2Fsocialistmodernism.com%2Fplaceholder-image%2F&tbnid=2vPMmqYJEzuiWM&vet=12ahUKEwjWsOXMyLr1AhWJmVMKHZ6ADi8QMygAegUIARCcAQ..i&docid=jKN_oULurygfxM&w=800&h=600&q=placeholder%20image&ved=2ahUKEwjWsOXMyLr1AhWJmVMKHZ6ADi8QMygAegUIARCcAQ '}
                title = {place.name}
            />

            <CardContent className = {classes.cardContent}>
                {/* Name of Place */}
                <Typography gutterButtom variant = "h5"><a href = {place.website} style={{ textDecoration: 'none' , color : 'black'}}>{place.name} </a></Typography>
                {/* Price range of place */}
                <Box display = "flex" justifyContent="space-between">
                    <Rating size = "small" value = {Number(place.rating)} readOnly />
                    <Typography gutterBottom variant = "subtitle1">Out of {place.num_reviews} reviews</Typography>
                </Box>
                <Box display = "flex" justifyContent="space-between">
                    <Typography variant = "subtitle1">Price</Typography>
                    <Typography gutterBottom variant = "subtitle1">{place.price_level}</Typography>
                </Box>
                {/* Ranking of place */}
                {/* <Box display = "flex" justifyContent="space-between">
                    <Typography variant = "subtitle1">Ranking</Typography>
                    <Typography gutterBottom variant = "subtitle1">{place.ranking}</Typography>
                </Box> */}
                {/* Map over tags */}
                {place?.cuisine?.map(({ name }) => (
                    <Chip key ={name} size = "small" label = {name} className = {classes.chip}/>
                ))}
                {/* Address of place */}
                {place?.address && (
                    <Typography gutterBottom variant = "subtitle2" color = "textSecondary" className = {classes.subtitle}>
                        <LocationOnIcon /> {place.address}
                    </Typography>
                )}
                {place?.phone && (
                    <Typography gutterBottom variant = "subtitle2" color = "textSecondary" className = {classes.spacing}>
                        <PhoneIcon /> {place.phone}
                    </Typography>
                )}
                {/* <CardActions>
                    <Button size = "small" color = "primary" onClick ={() => window.open(place.website, '_blank')}>Website</Button>
                </CardActions> */}
            </CardContent>

        </Card>
    /* </Grid> */
    )
}

export default PlaceDetails;